import { Stack, Typography } from '@mui/material'

import {
  Maybe,
  RelatedMissionDetailFragment,
} from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { ItemsMissionBox, ItemsMissionBoxProps } from '@/components/organisms'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

export * from './fragments'

export type State = {
  relatedMissions: Maybe<RelatedMissionDetailFragment[]>
}

type ItemsMissionBoxListCellProps = {
  relatedMissions: State['relatedMissions']
  onSubmitAnswerItem: Action['onSubmitAnswerItem']
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmitAnswerItem: ItemsMissionBoxProps['onSubmitAnswerItem']
}

export const ItemMissionsTemplate: Template<State, Action> = ({
  state,
  onSubmitAnswerItem,
}) => {
  const { t } = useTranslation('itemMissions')
  const { routerNames } = useRouter()
  return (
    <>
      <Head title={routerNames.ItemMissions} />
      <BaseLayout margin header={{ back: true, title: t('title') }}>
        <Typography variant="body2" sx={{ pt: 2 }}>
          {t('desc')}
        </Typography>
        <ItemsMissionBoxListCell
          relatedMissions={state.relatedMissions}
          onSubmitAnswerItem={onSubmitAnswerItem}
        />
      </BaseLayout>
    </>
  )
}

const ItemsMissionBoxListCell: Cell<ItemsMissionBoxListCellProps> = ({
  relatedMissions,
  onSubmitAnswerItem,
}) => (
  <CellFrame sx={{ pt: 3, pb: 5 }}>
    <Stack spacing={7}>
      {relatedMissions?.map(
        ({ id, reward, content, label, formattedExpiredAt }) => (
          <ItemsMissionBox
            key={id}
            missionId={id}
            item={content?.items ?? []}
            label={label ?? null}
            formattedExpiredAt={formattedExpiredAt ?? ''}
            number={reward.gachaTicket?.count ?? 0}
            onSubmitAnswerItem={onSubmitAnswerItem}
          />
        )
      )}
    </Stack>
  </CellFrame>
)
